// extracted by mini-css-extract-plugin
module.exports = {"flex":"DeliveryMode_style_flex__N-veS","label":"DeliveryMode_style_label__3d-ri","tip":"DeliveryMode_style_tip__1JBTj","bg":"DeliveryMode_style_bg__J5WYH"};